import React, { useEffect, useState } from 'react'
import styles from './homepage.module.css'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import Phrases from './phrases'
import Slider from './slider'
import { useSelector } from 'react-redux'
import { Personalidades } from '../../data/personality'
import { isEmpty } from '../../utils/functions'
import Swal from 'sweetalert2'

const Homepage: React.FC = (): JSX.Element => {
    const user = useSelector((state: any) => state.user)
    const [selected, setSelected] = useState<string | null>(null)

    useEffect(() => {
        const personalidad = localStorage.getItem('personality')
        if (!isEmpty(personalidad)) {
            setSelected(personalidad)
        } else if (Object.entries(user).length > 0) {
            Swal.fire(
                'Selecciona personalidad',
                'Debes seleccionar una personalidad para poder usar el sistema',
                'warning'
            )
        }
    }, [user])

    const handleSelect = (id: string) => {
        setSelected(id)
        localStorage.setItem('personality', id)
    }

    return Object.entries(user).length === 0 ? (
        <div className={styles.body}>
            <div className={styles.content}>
                <div className={styles.header}>
                    <div className={styles.title_container}>
                        <div className={styles.title1}>EL CAMINO DE</div>
                        <div className={styles.title2}>LA SUPERACION</div>
                    </div>
                    <div className={styles.frase_container}>
                        <div className={styles.title_frase}>
                            <Phrases />
                        </div>
                        <div className={styles.line}></div>
                        <div className={styles.frase}>
                            Convierte tus dudas e indecisiones en certezas accediendo a un antiguo plano de respuestas
                            de la mano del tarot.
                        </div>
                    </div>
                </div>

                <div className={styles.swiper_container}>
                    <Slider />
                </div>
            </div>
            {/* <img
        src={require("../../assets/images/homepage/background.png")}
        alt=""
        className={styles.cards}
      /> */}
        </div>
    ) : (
        <div className="relative w-full h-full min-h-screen bg-no-repeat bg-cover bg-homepage mini:px-2 md:px-4">
            <p className="w-full py-5 italic font-bold text-center text-white mini:text-xl xl:text-4xl drop-shadow-lg">
                Selecciona la Personalidad de tu Tarotista
            </p>
            <div className="flex flex-wrap justify-center gap-8">
                {Object.entries(Personalidades).map(([id, tarotista]) => (
                    <div key={id} className="relative w-64 h-96 [perspective:1000px] group">
                        {/* FLIP CONTAINER */}
                        <div
                            className={`
              relative w-full h-full transition-transform duration-700 
              [transform-style:preserve-3d]
              ${selected === id ? '[transform:rotateY(180deg)]' : ''}
              group-hover:[transform:rotateY(180deg)]
            `}
                        >
                            {/* FRENTE: IMAGEN + NOMBRE + MAZO */}
                            <div className="absolute inset-0 [backface-visibility:hidden] bg-white rounded-3xl shadow-xl overflow-hidden">
                                <img
                                    src={require('../../assets' + tarotista.image)}
                                    alt={tarotista.name}
                                    className="object-cover w-full h-full"
                                />
                                <div className="absolute bottom-0 left-0 right-0 p-4 text-white bg-gradient-to-t from-black/80 to-transparent">
                                    <h3 className="text-xl font-bold">{tarotista.name}</h3>
                                </div>
                            </div>

                            {/* ATRÁS: DESCRIPCIÓN + BOTÓN */}
                            <div className="absolute inset-0 [backface-visibility:hidden] [transform:rotateY(180deg)] bg-gradient-to-br from-purple-600 to-indigo-700 rounded-3xl p-6 flex flex-col justify-center items-center text-white shadow-2xl">
                                <h3 className="mb-3 text-2xl font-bold">{tarotista.name}</h3>
                                <p className="px-4 mb-6 text-sm leading-relaxed text-center">{tarotista.description}</p>
                                <button
                                    onClick={() => handleSelect(id)}
                                    className={`
                    px-6 py-3 rounded-full font-bold text-lg transition-all
                    ${
                        selected === id
                            ? 'bg-white text-purple-700 shadow-lg'
                            : 'bg-white/20 hover:bg-white/40 backdrop-blur-sm'
                    }
                  `}
                                >
                                    {selected === id ? 'Seleccionada' : 'Seleccionar'}
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Homepage
